

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/test/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/7.DN0an83A.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/CWir8Kn7.js","_app/immutable/chunks/Dx3bPppY.js","_app/immutable/chunks/CQrtv1eE.js","_app/immutable/chunks/sUv9qCDn.js"];
export const stylesheets = ["_app/immutable/assets/Editor.DxLOL-k3.css"];
export const fonts = [];
